/**
 * Anteprima all'hover delle miniature in TUTTE le liste prodotti.
 *
 * Due tipi di miniatura:
 *   - liste a tabella (catalogo, ricerca, piu' ordinati, carrello): markup di
 *     snippets/okko-zoom-img.liquid, <a class="image okko-zoom"
 *     data-okko-zoom="url-foto-grande">;
 *   - liste delle modali (bozza d'ordine, anteprima Ordine Rapido, Salvati,
 *     Ordini, cart drawer): <div class="okko-qo-row__img"><img src="...80px">,
 *     generate da window.OKKO.ui.modalRow o dal Liquid degli Ordini. Qui la foto
 *     grande si ricava dall'URL della miniatura (width=1400, via height/crop).
 *
 * Solo puntatore fine (@media hover): col mouse sopra la miniatura compare un
 * riquadro flottante NON modale con la foto grande. Ci si puo' entrare (per
 * selezionare e copiare lo SKU della card): uscendo dalla miniatura si chiude
 * solo se entro 250ms il mouse non e' arrivato nel riquadro, e si chiude
 * uscendo dal riquadro. Ritardo di 120ms in apertura: scorrendo la lista col
 * mouse non lampeggia a ogni riga.
 * Il click e' del markup (link alla scheda nelle tabelle, niente nelle modali).
 * Su touch questo script non fa nulla.
 *
 * TOP LAYER: le modali sono <dialog>.showModal(), stanno nel top layer e uno
 * z-index non le supera mai. Il riquadro e' quindi un popover="manual"
 * (showPopover lo mette nel top layer SOPRA la modale aperta); senza Popover
 * API si ripiega appendendolo dentro la dialog aperta.
 *
 * Tutto delegato al document: le righe cambiano con lo swap AJAX dei filtri e
 * le modali si ridisegnano da sole, non serve ri-agganciare nulla.
 *
 * CARD: se la miniatura contiene un <template data-okko-card> (dati scelti
 * dall'editor coi blocchi "Anteprima · campo", reso da
 * snippets/okko-anteprima-card.liquid) il riquadro diventa una card: foto
 * sopra, dati sotto. Senza template resta la sola foto.
 */
(function () {
  'use strict';

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const SEL = '[data-okko-zoom], .okko-qo-row__img';
  let chiusura = 0;
  let pop = null;      // il riquadro dell'anteprima (uno solo, riusato)
  let sopra = null;    // la miniatura sotto il mouse
  let mostrata = null; // la miniatura di cui si sta mostrando l'anteprima
  let timer = 0;

  function ensurePop() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'okko-zoom-pop';
    pop.setAttribute('aria-hidden', 'true');
    if (typeof pop.showPopover === 'function') pop.setAttribute('popover', 'manual');
    pop.innerHTML = '<div class="okko-zoom-pop__foto"><img alt=""></div><div class="okko-zoom-pop__card"></div>';
    document.body.appendChild(pop);
    return pop;
  }

  /** URL della foto grande: l'attributo del markup a tabella, oppure quello
   *  della miniatura delle modali portato a 1400px (senza ritaglio). */
  function fotoGrande(el) {
    if (el.dataset.okkoZoom) return el.dataset.okkoZoom;
    const img = el.querySelector('img');
    const src = img && (img.currentSrc || img.getAttribute('src'));
    if (!src) return '';
    try {
      const u = new URL(src, window.location.href);
      u.searchParams.set('width', '1400');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.toString();
    } catch (e) { return src; }
  }

  /** Porta il riquadro sopra tutto: top layer col Popover API (riaperto ogni
   *  volta, cosi' sta sopra anche a una modale aperta DOPO), altrimenti dentro
   *  la dialog aperta piu' recente. */
  function inCima(p) {
    clearTimeout(chiusura); chiusura = 0;
    if (p.hasAttribute('popover')) {
      try { if (p.matches(':popover-open')) p.hidePopover(); p.showPopover(); } catch (e) { /* ok */ }
      return;
    }
    const aperte = document.querySelectorAll('dialog[open]');
    const casa = aperte.length ? aperte[aperte.length - 1] : document.body;
    if (p.parentNode !== casa) casa.appendChild(p);
  }

  /** A destra della miniatura; a sinistra se non ci sta; mai fuori dal viewport. */
  function posiziona(el) {
    const p = ensurePop();
    const r = el.getBoundingClientRect();
    const W = p.offsetWidth || 320;
    const H = p.offsetHeight || 320;
    const gap = 12;
    let left = r.right + gap;
    if (left + W > window.innerWidth - 8) left = r.left - gap - W;
    if (left < 8) left = 8;
    let top = r.top + r.height / 2 - H / 2;
    top = Math.max(8, Math.min(top, window.innerHeight - H - 8));
    p.style.left = `${Math.round(left)}px`;
    p.style.top = `${Math.round(top)}px`;
  }

  /** Dati della card: dal template della miniatura, oppure niente (sola foto).
   *  Si riscrivono a ogni accensione: due varianti con la stessa foto hanno
   *  dati diversi (SKU, magazzino). */
  function riempiCard(el) {
    const p = ensurePop();
    const box = p.querySelector('.okko-zoom-pop__card');
    const tpl = el.querySelector('template[data-okko-card]');
    box.innerHTML = tpl ? tpl.innerHTML : '';
    p.classList.toggle('has-card', !!tpl);
  }

  function mostra(el) {
    const src = fotoGrande(el);
    if (!src) return;
    const p = ensurePop();
    const img = p.querySelector('img');
    mostrata = el;
    const accendi = () => {
      if (mostrata !== el) return;
      riempiCard(el);
      inCima(p);
      posiziona(el);
      // la classe al frame dopo: il riquadro e' appena passato da display:none
      requestAnimationFrame(() => { if (mostrata === el) p.classList.add('is-on'); });
    };
    if (img.getAttribute('src') === src) { accendi(); return; }
    // Immagine nuova: si decodifica A PARTE e si mette nel riquadro solo quando
    // e' pronta. Cambiando src direttamente l'<img> continua a mostrare la foto
    // precedente finche' la nuova non arriva (e `complete` mente nel frattempo):
    // passando da un prodotto all'altro si vedeva la foto sbagliata.
    p.classList.remove('is-on');
    const pre = new Image();
    pre.src = src;
    pre.decode().then(() => {
      if (mostrata !== el) return;
      img.src = src;
      accendi();
    }).catch(() => { if (mostrata === el) nascondi(); });
  }

  function nascondi() {
    clearTimeout(timer); timer = 0;
    clearTimeout(tChiudi); tChiudi = 0;
    nelPop = false;
    mostrata = null;
    if (!pop) return;
    pop.classList.remove('is-on');
    if (pop.hasAttribute('popover')) {
      clearTimeout(chiusura);
      // dopo la dissolvenza esce dal top layer (se nel frattempo non e' ripartito)
      chiusura = setTimeout(() => {
        if (!mostrata) { try { if (pop.matches(':popover-open')) pop.hidePopover(); } catch (e) { /* ok */ } }
      }, 160);
    }
  }

  // RIQUADRO RAGGIUNGIBILE (Nicolas, 2026-10-07: per copiare lo SKU dalla
  // card). Uscendo dalla miniatura non si chiude subito ma dopo
  // RITARDO_CHIUSURA, il tempo di attraversare i 12px fino al riquadro; se il
  // mouse ci entra resta aperto finche' non ne esce. Il CSS gli rida' i
  // pointer-events solo quando e' acceso.
  const RITARDO_CHIUSURA = 250;
  let tChiudi = 0;
  let nelPop = false;
  const chiudiFraPoco = () => {
    clearTimeout(tChiudi);
    tChiudi = setTimeout(() => { tChiudi = 0; if (!sopra && !nelPop) nascondi(); }, RITARDO_CHIUSURA);
  };

  document.addEventListener('mouseover', (e) => {
    if (pop && pop.contains(e.target)) {
      // dentro il riquadro: resta aperto, e salta l'apertura di un'altra
      // miniatura sfiorata per arrivarci
      nelPop = true;
      sopra = null;
      clearTimeout(tChiudi); tChiudi = 0;
      clearTimeout(timer); timer = 0;
      return;
    }
    // appena usciti dal riquadro sopra e' null come prima: senza questo il
    // "niente di nuovo" qui sotto non lo chiuderebbe mai
    const uscitoDalPop = nelPop;
    nelPop = false;
    const el = e.target.closest(SEL);
    if (el === sopra && !uscitoDalPop) return;
    sopra = el;
    clearTimeout(timer); timer = 0;
    if (!el) {
      // trascinando per selezionare il testo del riquadro si puo' sbordare:
      // finche' il tasto e' giu' non si chiude
      if (mostrata && (e.buttons & 1)) return;
      if (mostrata) chiudiFraPoco(); else nascondi();
      return;
    }
    // tornati sulla miniatura gia' mostrata (dal riquadro o dal varco)
    if (el === mostrata) { clearTimeout(tChiudi); tChiudi = 0; return; }
    timer = setTimeout(() => { if (sopra === el) mostra(el); }, 120);
  });
  // mouse fuori dalla finestra: mouseover non arriva piu'
  document.documentElement.addEventListener('mouseleave', () => { sopra = null; nascondi(); });
  // scroll (anche dentro la tabella): la miniatura si sposta, l'anteprima no
  document.addEventListener('scroll', () => { if (sopra || mostrata) { sopra = null; nascondi(); } }, { passive: true, capture: true });
  window.addEventListener('resize', () => { sopra = null; nascondi(); });
  // click (link alla scheda, espansione varianti, altro): via l'anteprima.
  // Non i click DENTRO il riquadro: servono a selezionare il testo.
  document.addEventListener('click', (e) => {
    if (pop && pop.contains(e.target)) return;
    sopra = null; nascondi();
  });
})();
